import React from 'react';
import Modal from '../../../components/ui/Modal';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import SuccessCelebration from '../../../components/ui/SuccessCelebration';

const AchievementPopup = ({ isOpen, onClose, score, interviewType, userName }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            hideHeader={true}
            size="md"
            className="overflow-hidden relative border-none bg-transparent"
        >
            <SuccessCelebration type="interview" />
            
            <div className="relative bg-white/90 backdrop-blur-xl rounded-[2.5rem] p-10 shadow-2xl border border-white/50 flex flex-col items-center text-center overflow-hidden">
                {/* Decorative Background Blurs */}
                <div className="absolute top-0 right-0 w-40 h-40 bg-primary/10 rounded-full blur-3xl -mr-20 -mt-20" />
                <div className="absolute bottom-0 left-0 w-40 h-40 bg-secondary/10 rounded-full blur-3xl -ml-20 -mb-20" />

                {/* Trophy Section */}
                <div className="relative mb-8 pt-4">
                    <div className="absolute inset-0 bg-yellow-400/20 rounded-full blur-3xl scale-150 animate-pulse" />
                    <div className="relative w-32 h-32 rounded-full bg-gradient-to-br from-yellow-100 to-amber-50 flex items-center justify-center border-4 border-white shadow-xl rotate-3">
                        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-yellow-400 via-amber-500 to-orange-600 flex items-center justify-center shadow-inner">
                            <Icon name="Trophy" size={48} color="#FFFFFF" className="drop-shadow-lg" />
                        </div>
                    </div>
                    {/* Sparkles */}
                    <div className="absolute -top-2 -right-2 animate-bounce">
                        <Icon name="Sparkles" size={24} className="text-yellow-500" />
                    </div>
                </div>

                <div className="space-y-4 relative z-10">
                    <div>
                        <span className="text-[10px] font-black tracking-[0.3em]text-primary/60 mb-2 block">Achievement Unlocked</span>
                        <h2 className="text-4xl font-black text-slate-900 leading-tight">
                            Excellent Work, <span className="bg-gradient-primary bg-clip-text text-transparent">{userName}</span>!
                        </h2>
                    </div>

                    <p className="text-slate-600 text-sm max-w-sm mx-auto leading-relaxed">
                        You've successfully completed your <span className="font-bold text-slate-900">{interviewType} interview</span> with an impressive performance score.
                    </p>

                    <div className="py-6 flex flex-col items-center">
                        <div className="relative inline-flex items-center justify-center">
                            <svg className="w-32 h-32 transform -rotate-90">
                                <circle
                                    cx="64"
                                    cy="64"
                                    r="58"
                                    stroke="currentColor"
                                    strokeWidth="12"
                                    fill="transparent"
                                    className="text-slate-100"
                                />
                                <circle
                                    cx="64"
                                    cy="64"
                                    r="58"
                                    stroke="currentColor"
                                    strokeWidth="12"
                                    fill="transparent"
                                    strokeDasharray={364.4}
                                    strokeDashoffset={364.4 - (364.4 * score) / 100}
                                    strokeLinecap="round"
                                    className="text-primary transition-all duration-1000 ease-out"
                                />
                            </svg>
                            <div className="absolute inset-0 flex flex-col items-center justify-center">
                                <span className="text-3xl font-black text-slate-900">{score}%</span>
                                <span className="text-[8px] font-bold text-slate-400tracking-widest">Score</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-full grid grid-cols-2 gap-4 mt-8">
                    <Button
                        variant="outline"
                        onClick={onClose}
                        fullWidth
                        className="rounded-2xl border-slate-200 text-slate-600 font-bold hover:bg-slate-50 h-14"
                    >
                        View Details
                    </Button>
                    <Button
                        variant="default"
                        fullWidth
                        className="rounded-2xl bg-slate-900 text-white font-bold hover:bg-slate-800 transition-all shadow-xl h-14"
                        iconName="Share2"
                        iconPosition="left"
                    >
                        Share
                    </Button>
                </div>
                
                <button 
                    onClick={onClose}
                    className="mt-6 text-[10px] font-bold text-slate-400tracking-widest hover:text-slate-600 transition-colors"
                >
                    Dismiss for now
                </button>
            </div>
        </Modal>
    );
};

export default AchievementPopup;
